import React, { useEffect, useState } from 'react'
import ModalBasic from '../../pages/component/ModalBasic';
import * as XLSX from "xlsx";




export default function SelectMemberModel(props) {

    const [allMemberArr, setAllMemberArr] = useState([]);
    const [selectedMemberArr, setSelectedMemberArr] = useState([]);
    const [memberType, setMemberType] = useState("");

    useEffect(() => {
        if (props.memberId === 1) {
            setAllMemberArr(props.allCSISMember);
            setSelectedMemberArr(props.selectedCSISMember);
            // setMemberType("Fellow Members");
            setMemberType("CSIS Members");
        }
        // else if (props.memberId === 2) {
        //     setAllMemberArr(props.allAssociateMember);
        //     setSelectedMemberArr(props.selectedAssociateMember);
        //     setMemberType("Associate Members");
        // } 
        else if (props.memberId === 3) {
            setAllMemberArr(props.allCGIStudentMember);
            setSelectedMemberArr(props.selectedCGIMember);
            setMemberType("CGI Student");
        } else if (props.memberId === 4) {
            setAllMemberArr(props.allChapter);
            setSelectedMemberArr(props.selectedChapter);
            setMemberType("Chapter Members");
        } else if (props.memberId === 5) {
            setAllMemberArr(props.allNonMember);
            setSelectedMemberArr(props.selectedNonMember);
            setMemberType("Non Members");
        } else if (props.memberId === 6) {
            setAllMemberArr(props.allGradMember);
            setSelectedMemberArr(props.selectedGradMember);
            setMemberType("Grad Members");
        }
    }, [props.memberId, props.allCSISMember, props.allCGIStudentMember, props.allGradMember, props.allChapter, props.allNonMember,
    props.selectedCSISMember, props.selectedAssociateMember, props.selectedCGIMember,props.selectedGradMember,props.selectedNonMember, props.selectedChapter]);




    return (
        <div className="select-all-member-popup">
            <ModalBasic
                id="select-All-Members"
                modalOpen={props.selectAllMembersPopup}
                setModalOpen={() => props.setOpenModal(memberType)}
            >
                <div className="bg-white mb-10">
                    <div className="">
                        <div className="grid grid-cols-12 2xl:gap-6 gap-3 w-full 2xl:px-10 lg:px-3 pr-0">
                            <div className="xl:col-span-12 lg:col-span-12 col-span-12">
                                <h1 className="text-4xl text-[#e5322b] font-bold leading-loose py-4">
                                    {props.memberId === 1 ? "Select CSIS Members" :
                                        props.memberId === 3 ? "Select CGI Student" :
                                            props.memberId === 5 ? "Select Non Members" :
                                                props.memberId === 6 ? "Select Grad Members" : "Select All Members"}
                                </h1>
                            </div>
                            <div className="col-span-12">
                                <div className="grid grid-cols-12 2xl:gap-6 gap-3 items-center">

                                    {

                                        props.memberId === 5 ? '' :
                                            <div className="col-span-5">
                                                <div className="border border-[#757575] p-5">
                                                    <div className="list-members">
                                                        <input
                                                            className="input-texts form-input rounded-none w-full shadow-red py-3 text-lg"
                                                            placeholder="Search"
                                                            type="text"
                                                            value={props.allMemberSearchValue}
                                                            onChange={(event) => props.searchByName(event.target.value, memberType, "All")}
                                                        />
                                                        <div className="table-listing mt-5">
                                                            <table className="w-full bg-white shadow-lg rounded-sm border border-slate-200">
                                                                {/* Table body */}
                                                                <tbody className="text-sm custom-tbody">
                                                                    {allMemberArr.map(
                                                                        (mem, key) => {
                                                                            return (
                                                                                <>{
                                                                                    mem.isShowData === true ?
                                                                                        <tr className="custom-tbl-td" key={key}>
                                                                                            <td className="px-2 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt pointer text-[#757575]">
                                                                                                <div className="check-box-sec flex items-center">
                                                                                                    <input
                                                                                                        id={`Member_/_${memberType}_A/${key}`}
                                                                                                        name={`Member_/_${memberType}_A/${key}`}
                                                                                                        type="checkbox"
                                                                                                        className="form-checkbox"
                                                                                                        checked={mem.isAllSelected}
                                                                                                        value={mem.isAllSelected}
                                                                                                        onChange={(event) => props.handleChangeCheckBoxForMembers(event, memberType, key, "All")}
                                                                                                    />
                                                                                                    <span className="block text-xl theme-color pl-4">
                                                                                                        {memberType === "Chapter Members" ?
                                                                                                            <>{mem.chapterName}</>
                                                                                                            : <> {mem.memberName}</>}

                                                                                                    </span>
                                                                                                </div>
                                                                                            </td>
                                                                                        </tr>
                                                                                        : null
                                                                                }
                                                                                </>
                                                                            );
                                                                        }
                                                                    )}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                    }
                                    <div className="col-span-2">
                                        <div className="center-btns">


                                            <div className="flex flex-col justify-center">

                                                {props.memberId !== 5 && (
                                                    <>
                                                        <button
                                                            className={`btn btn-red-border text-xl text-white 2xl:mb-8 mb-4 2xl:py-9 ${
                                                                props.voucherCodeDetails.isDisabled ? "disableVouchercode" : ""
                                                                }`}
                                                            onClick={() => props.assignMembers(memberType)}
                                                        >
                                                            Assign <span className="ml-3 fa fa-angle-right"></span>
                                                        </button>

                                                        <button
                                                            className={`btn btn-red-border text-xl text-white 2xl:my-8 my-4 2xl:py-9 ${
                                                                props.voucherCodeDetails.isDisabled ? "disableVouchercode" : ""
                                                                }`}
                                                            onClick={() => props.UnassignMembers(memberType)}
                                                        >
                                                            <span className="mr-3 fa fa-angle-left"></span> Unassign
                                                        </button>
                                                    </>
                                                )}

                                                {
                                                    props.memberId === 5 ?
                                                        <>
                                                            <form className="btn btn-lighblue-border text-xl text-white 2xl:mt-8 mt-4 2xl:py-9">
                                                                <label
                                                                    htmlFor="upload_File3"
                                                                    className="text-uplod block text-sm font-bold text-[#C00000] whitespace-nowrap cursor-pointer"
                                                                >
                                                                    Upload List
                                                                </label>
                                                                <input
                                                                    className="sr-only"
                                                                    id="upload_File3"
                                                                    type="file"
                                                                    name="file3"
                                                                    // onChange={(event) => this.onFileChange(event, "File3Details")}
                                                                    onChange={props.handleExcelUpload}
                                                                    accept=".xls, .xlsx"
                                                                />
                                                            </form>

                                                            <div className='mt-5'>
                                                        <button className="font-bold text-blue-400 text-[16px]" onClick={() => props.downloadFileFromUrl('/VoucherCode_upload.xlsx') }>
                                                                    Download Template
                                                                </button>
                                                            </div>
                                                        </>
                                                        : ''
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`col-span-${props.memberId === 5 ? 12 : 5}`}>
                                        <div className="border border-[#757575] p-5">
                                            <div className="list-members">
                                                <input
                                                    className="input-texts form-input rounded-none w-full shadow-red py-3 text-lg"
                                                    placeholder="Search"
                                                    type="text"
                                                    value={props.selectedMemberSearchValue}
                                                    onChange={(event) => props.searchByName(event.target.value, memberType, "Selected")}
                                                />
                                                <div className="table-listing mt-5">
                                                    <table className="w-full bg-white shadow-lg rounded-sm border border-slate-200">
                                                        {/* Table body */}
                                                        <tbody className="text-sm custom-tbody">
                                                            {selectedMemberArr.map(
                                                                (mem, key) => {
                                                                    return (
                                                                        <>
                                                                            {mem.isShowData === true ?
                                                                                <tr className="custom-tbl-td" key={key}>
                                                                                    <td className="px-2 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt pointer text-[#757575]">
                                                                                        <div className="check-box-sec flex items-center">

                                                                                            {
                                                                                                props.memberId !== 5 ?
                                                                                                    <input
                                                                                                        id={`Member_/_${memberType}_S/${key}`}
                                                                                                        name={`Member_/_${memberType}_S/${key}`}
                                                                                                        type="checkbox"
                                                                                                        className="form-checkbox"
                                                                                                        checked={mem.isSelected}
                                                                                                        value={mem.isSelected}
                                                                                                        onChange={(event) => props.handleChangeCheckBoxForMembers(event, memberType, key, "Selected")}
                                                                                                    /> : null

                                                                                            }

                                                                                            <span className="block text-xl theme-color pl-4">
                                                                                                {/* {memberType === "Chapter Members" ?
                                                                                                    <>{mem.chapterName}</>
                                                                                                    : <> {mem.memberName}</>} */}

                                                                                                {memberType === "Non Member" ?
                                                                                                    <>{mem.memberName}</>
                                                                                                    : <> {mem.memberName}</>}

                                                                                            </span>
                                                                                        </div>
                                                                                    </td>
                                                                                </tr>
                                                                                : null}
                                                                        </>

                                                                    );
                                                                }
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ModalBasic>
        </div>
    )
}
